/**
 * Created by daniesy on 09/11/2016.
 */
var d3 = require('d3');
export default class ChartData {
    constructor(data) {
        this._spxData = [];
        this._ctaData = [];
        this._events = [];
        this.extractData(data);
    }

    extractData(data) {
        this._spxData = data.map(data => this.mapData(data, 'spx'));
        this._ctaData = data.map(data => this.mapData(data, 'cta'));
        this._events = data.map((data, i) => { return { formattedDate: data.date, date: d3.timeParse("%d-%m-%Y")(data.date), value: data.spx, event: data.event}}).filter(data => data.event);
    }

    mapData(subData, columnName) {
        let price = +subData[columnName];
        return {date: d3.timeParse("%d-%m-%Y")(subData.date), price: price};
    }

    get spx() {
        return this._spxData;
    }

    get cta() {
        return this._ctaData;
    }

    get events() {
      return this._events;
    }

}



// WEBPACK FOOTER //
// ./src/js/chartData.js